import React from 'react'
import { Table } from 'react-bootstrap'
import DisplayLabel from '../../components/DisplayLabel'
import { get } from 'lodash'

export default class SearchResults extends React.Component {

  render() {
    const { searchResults, full } = this.props
    return <Table striped>
      <thead>
        <tr>
          { full && <th>Product</th> }
          <th>Eigenaar</th>
          { full && <th>WebshopOrderItemId</th> }
          { full && <th>NavisionId</th> }
          <th>Activatiecode</th>
          <th>Status</th>
          <th>Werkmaatschappij</th>
        </tr>
      </thead>
      <tbody>
        { searchResults.map((license, index) =>
          <tr key={index} onClick={() => this.props.history.push(`/licenties/${license.id}`)}>
            {
              full && (
                <td>
                  <p>{get(license, 'product.name')}</p>
                  <p>{get(license, 'product.ean')}</p>
                </td>
                )
            }
            <td><DisplayLabel type='OWNER' value={license} /></td>
            { full && <td style={{overflowWrap: "anywhere"}}>{license.webshopOrderItemId}</td> }
            { full && <td style={{overflowWrap: "anywhere"}}>{license.navisionId}</td> }
            <td>{license.activationCode}</td>
            <td>{license.status} </td>
            <td>{license.subsidiary.name}</td>
          </tr>
        )}
      </tbody>
    </Table>
  }
}
